
import filters from "@/filters";
import { Component, Prop, Vue } from "vue-property-decorator";
import { CourseSectionEnum, EnumHelper } from "@/constants/enum.constant";

@Component({
  components: {},
  filters,
})
export default class ModalStartTest extends Vue {
  @Prop({ default: CourseSectionEnum.PRE_TEST })
  private section!: number;
  @Prop({ default: 0 })
  private remaining!: number;
  @Prop({ default: 0 })
  private value!: number;

  private sections = EnumHelper(CourseSectionEnum);

  private get isPreTest() {
    return this.section === CourseSectionEnum.PRE_TEST;
  }
  private get isPostTest() {
    return this.section === CourseSectionEnum.POST_TEST;
  }

  private cancel() {
    this.$bvModal.hide("modal-start-test");
  }

  private start() {
    if (this.remaining > 0) {
      this.$bvModal.hide("modal-start-test");
      this.$emit("start");
    }
  }
}
